var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subTop"},[_c('div',{staticClass:"topTitle"},[_c('p',{staticClass:"cate"},[_vm._v(_vm._s(_vm.depth1.name))]),_c('p',{staticClass:"subCate"},[_vm._v(_vm._s(_vm.depth2.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }